const debug = false;
export class Netvio {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.firmwareVersion = 'CL 1.1.81 (emulator)';
        this.username = 'admin';
        this.endpoints = {};
        this.asyncHandlers = [
            {
                name: 'get_audio_volume',
                match: (req) => (req.method === 'get_audio_volume' ? req : undefined),
                callback: (req) => {
                    var _a, _b, _c, _d, _e, _f;
                    const audioChannel = req.params.target;
                    const proc = this.getVolumeAndMute(audioChannel);
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        method: req.method,
                        result: {
                            endpointID: audioChannel,
                            processID: (_b = proc === null || proc === void 0 ? void 0 : proc.processID) !== null && _b !== void 0 ? _b : 1,
                            processName: (_c = proc === null || proc === void 0 ? void 0 : proc.processName) !== null && _c !== void 0 ? _c : 'noProcessing',
                            audioOutVolume: (_d = proc === null || proc === void 0 ? void 0 : proc.audioOutVolume) !== null && _d !== void 0 ? _d : 0,
                            audioOutMute: (_e = proc === null || proc === void 0 ? void 0 : proc.audioOutMute) !== null && _e !== void 0 ? _e : false,
                            audioOutDelay: (_f = proc === null || proc === void 0 ? void 0 : proc.audioOutDelay) !== null && _f !== void 0 ? _f : 0,
                        },
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
            {
                name: 'set_audio_volume',
                match: (req) => (req.method === 'set_audio_volume' ? req : undefined),
                callback: (req) => {
                    var _a, _b, _c;
                    const audioChannel = req.params.target;
                    const mute = (_a = req.params) === null || _a === void 0 ? void 0 : _a.audioOutMute;
                    const volume = (_b = req.params) === null || _b === void 0 ? void 0 : _b.audioOutVolume;
                    const proc = this.getVolumeAndMute(audioChannel);
                    if (proc) {
                        if (mute)
                            proc.audioOutMute = mute;
                        if (volume)
                            proc.audioOutVolume = volume;
                        const response = {
                            id: (_c = req === null || req === void 0 ? void 0 : req.id) !== null && _c !== void 0 ? _c : '1',
                            jsonrpc: req.jsonrpc,
                            result: {
                                cmdStatus: 'success',
                            },
                        };
                        this.socket.send(JSON.stringify(response));
                    }
                },
            },
            {
                name: 'get_session_login',
                match: (req) => (req.method === 'get_session_login' ? req : undefined),
                callback: (req) => {
                    var _a;
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        method: req.method,
                        result: {
                            username: this.username,
                            type: 'tcp',
                            sessionID: 1,
                        },
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
            {
                name: 'set_session_login',
                match: (req) => (req.method === 'set_session_login' ? req : undefined),
                callback: (req) => {
                    var _a;
                    this.username = req.params.username;
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        result: {
                            cmdStatus: 'success',
                        },
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
            {
                name: 'set_session_logout',
                match: (req) => (req.method === 'set_session_logout' ? req : undefined),
                callback: (req) => {
                    var _a;
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        result: {
                            cmdStatus: 'success',
                        },
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
            {
                name: 'get_endpoint',
                match: (req) => (req.method === 'get_endpoint' ? req : undefined),
                callback: (req) => {
                    var _a;
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        method: req.method,
                        result: [this.controller, ...Object.values(this.endpoints)],
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
            {
                name: 'get_devicefw',
                match: (req) => (req.method === 'get_device_fw' ? req : undefined),
                callback: (req) => {
                    var _a;
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        method: req.method,
                        result: { fwVersion: `${this.firmwareVersion}` },
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
            {
                name: 'get_matrix_assign',
                match: (req) => (req.method === 'get_matrix_assign' ? req : undefined),
                callback: (req) => {
                    var _a, _b, _c, _d, _e;
                    let response;
                    const outputSignalNode = (_a = req.params) === null || _a === void 0 ? void 0 : _a.signalNode;
                    const outputTarget = (_b = req.params) === null || _b === void 0 ? void 0 : _b.target;
                    if (outputSignalNode) {
                        // Switching the specific signal
                        const inputSignalNode = (_c = this.getMatrixRouting(outputSignalNode)) !== null && _c !== void 0 ? _c : '';
                        response = {
                            id: (_d = req === null || req === void 0 ? void 0 : req.id) !== null && _d !== void 0 ? _d : '1',
                            jsonrpc: req.jsonrpc,
                            method: req.method,
                            result: { signalNode: outputSignalNode, assignSignal: inputSignalNode },
                        };
                        this.socket.send(JSON.stringify(response));
                    }
                    else if (outputTarget) {
                        // Switching all signals
                        const targetSignals = this.endpoints[outputTarget].signals;
                        const result = this.createNotifySignals(targetSignals);
                        response = {
                            id: (_e = req === null || req === void 0 ? void 0 : req.id) !== null && _e !== void 0 ? _e : '1',
                            jsonrpc: req.jsonrpc,
                            result: {
                                endpointID: outputTarget,
                                signals: result,
                            },
                        };
                        this.socket.send(JSON.stringify(response));
                    }
                },
            },
            {
                name: 'set_matrix_assign',
                match: (req) => (req.method === 'set_matrix_assign' ? req : undefined),
                callback: (req) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const outputSignalNode = (_a = req.params) === null || _a === void 0 ? void 0 : _a.signalNode;
                    const inputSignalNode = (_c = (_b = req.params) === null || _b === void 0 ? void 0 : _b.assignSignal) !== null && _c !== void 0 ? _c : '';
                    // Used when switching all signals
                    const outputSignalID = (_d = req.params) === null || _d === void 0 ? void 0 : _d.target;
                    const inputSignalID = (_e = req.params) === null || _e === void 0 ? void 0 : _e.assign;
                    if (outputSignalNode && inputSignalNode) {
                        // After routing a video or audio channel, the controller responds with async
                        // responses about the audio/video/serial/ir/usb signal changes for the new
                        // input mapped to the output channel, and updates to the input signals to
                        // indicate their signals are no longer assigned to specific
                        // output channels.
                        const prevInputNode = this.getCurrentAssignedSignal(outputSignalNode);
                        let result = [];
                        // Assign the input to the output and Notify that the current output is
                        // assigned an input channel
                        result = this.assignSignal(outputSignalNode, inputSignalNode, 'add');
                        // Matrix routing response
                        const response = {
                            id: (_f = req === null || req === void 0 ? void 0 : req.id) !== null && _f !== void 0 ? _f : '1',
                            jsonrpc: req.jsonrpc,
                            method: req.method,
                            result: { cmdStatus: 'success' },
                        };
                        this.socket.send(JSON.stringify(response));
                        //Async matrix notify responses
                        if (result) {
                            const targetEndpointID = this.getEndpointIDFromSignal(outputSignalNode);
                            const response = {
                                jsonrpc: '2.0',
                                method: 'notify_matrix_assign',
                                params: {
                                    endpointID: targetEndpointID,
                                    signals: result,
                                },
                            };
                            this.socket.send(JSON.stringify(response));
                        }
                        // Notify that the current input is assigned to the output channel
                        result = this.assignSignal(inputSignalNode, outputSignalNode, 'add');
                        if (result) {
                            const targetEndpointID = this.getEndpointIDFromSignal(inputSignalNode);
                            const response = {
                                jsonrpc: '2.0',
                                method: 'notify_matrix_assign',
                                params: {
                                    endpointID: targetEndpointID,
                                    signals: result,
                                },
                            };
                            this.socket.send(JSON.stringify(response));
                        }
                        // Notify that the previous input is no longer being used by the output channel
                        if (prevInputNode && prevInputNode !== inputSignalNode) {
                            result = this.assignSignal(prevInputNode, outputSignalNode, 'remove');
                            if (result) {
                                const targetEndpointID = this.getEndpointIDFromSignal(prevInputNode);
                                const response = {
                                    jsonrpc: '2.0',
                                    method: 'notify_matrix_assign',
                                    params: {
                                        endpointID: targetEndpointID,
                                        signals: result,
                                    },
                                };
                                this.socket.send(JSON.stringify(response));
                            }
                        }
                    }
                    else if (inputSignalID && outputSignalID) {
                        // routing all channels, so update all signalNode assignments
                        if (debug)
                            this.log.debug(`emulator - routing all signals for ${outputSignalID}`);
                        const targetSignals = this.endpoints[outputSignalID].signals;
                        const srcSignals = this.endpoints[inputSignalID].signals;
                        let previousInputSignalNode;
                        // Assign all the signal nodes from the source to the target
                        for (const targetSignal of targetSignals !== null && targetSignals !== void 0 ? targetSignals : []) {
                            const targetSignalType = (_g = targetSignal === null || targetSignal === void 0 ? void 0 : targetSignal.type) !== null && _g !== void 0 ? _g : 'video';
                            const targetSignalNode = targetSignal === null || targetSignal === void 0 ? void 0 : targetSignal.signalNode;
                            const targetIsTx = (targetSignalNode !== null && targetSignalNode !== void 0 ? targetSignalNode : '').includes('tx');
                            if (debug) {
                                this.log.debug(`targetSignalNode = ${targetSignalNode}, isTx: ${targetIsTx}`);
                            }
                            const sourceSignalNode = this.findSignalNode(srcSignals, targetSignalType, targetIsTx);
                            previousInputSignalNode = this.getCurrentAssignedSignal(targetSignalNode);
                            if (debug) {
                                this.log.debug(`emulator: assigning target: ${targetSignalNode}, src: ${sourceSignalNode}`);
                            }
                            if (targetSignalNode && sourceSignalNode) {
                                this.assignSignal(targetSignalNode, sourceSignalNode, 'add');
                                this.assignSignal(sourceSignalNode, targetSignalNode, 'add');
                                if (previousInputSignalNode) {
                                    this.assignSignal(previousInputSignalNode, targetSignalNode, 'remove');
                                }
                            }
                        }
                        // Matrix routing response
                        const response = {
                            id: (_h = req === null || req === void 0 ? void 0 : req.id) !== null && _h !== void 0 ? _h : '1',
                            jsonrpc: req.jsonrpc,
                            method: req.method,
                            result: { cmdStatus: 'success' },
                        };
                        this.socket.send(JSON.stringify(response));
                        // return async notifications
                        const response1 = {
                            jsonrpc: '2.0',
                            method: 'notify_matrix_assign',
                            params: {
                                endpointID: outputSignalID,
                                signals: this.createNotifySignalsFromEndpoint(outputSignalID),
                            },
                        };
                        this.socket.send(JSON.stringify(response1));
                        const response2 = {
                            jsonrpc: '2.0',
                            method: 'notify_matrix_assign',
                            params: {
                                endpointID: inputSignalID,
                                signals: this.createNotifySignalsFromEndpoint(inputSignalID),
                            },
                        };
                        this.socket.send(JSON.stringify(response2));
                        const prevEndpointID = this.getEndpointIDFromSignal(previousInputSignalNode);
                        if (prevEndpointID) {
                            const response3 = {
                                jsonrpc: '2.0',
                                method: 'notify_matrix_assign',
                                params: {
                                    endpointID: prevEndpointID,
                                    signals: this.createNotifySignalsFromEndpoint(prevEndpointID),
                                },
                            };
                            this.socket.send(JSON.stringify(response3));
                        }
                    }
                },
            },
            {
                name: 'invalid',
                match: (req) => req,
                callback: (req) => {
                    var _a;
                    const response = {
                        id: (_a = req === null || req === void 0 ? void 0 : req.id) !== null && _a !== void 0 ? _a : '1',
                        jsonrpc: req.jsonrpc,
                        method: req.method,
                        result: {
                            cmdStatus: 'error',
                        },
                    };
                    this.socket.send(JSON.stringify(response));
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['\r', '\n'],
        };
        const numEncoders = 16;
        const numDecoders = 16;
        this.controller = this.createController();
        // Adds to the endpoints object
        this.createEncoders(numEncoders);
        this.createDecoders(numDecoders);
    }
    parser(command) {
        try {
            const resp = JSON.parse(command);
            return resp;
        }
        catch (err) {
            return undefined;
        }
    }
    getCurrentAssignedSignal(outputSignalNode) {
        // out1-videorx1
        if (outputSignalNode) {
            const signals = this.findEndpointSignal(outputSignalNode);
            const result = signals === null || signals === void 0 ? void 0 : signals.assignSignal;
            if (Array.isArray(result))
                return result[0];
            return result;
        }
        return undefined;
    }
    // Updates the set of signal values for a channel creates the info for the response.
    // Target is the signalNode name that is either getting a new source assigned to it, or
    // having the source removed from its assigned node based on the add or remove action.
    assignSignal(targetSignal, srcSignal, action) {
        var _a, _b, _c;
        // Find the endpointID from the signal name
        const targetEndpointID = this.getEndpointIDFromSignal(targetSignal);
        // Example, routing in2's video signal to out1:
        //     target: out1-videorx1 , src: in2-videotx1
        if (targetEndpointID) {
            // Outputs can only have one assignSignal, inputs can be assigned to multiple outputs
            const targetIsOutput = targetEndpointID.startsWith('out');
            // Get video/audio/serial/etc signals associated with the target
            const targetSignals = (_b = (_a = this.endpoints[targetEndpointID]) === null || _a === void 0 ? void 0 : _a.signals) !== null && _b !== void 0 ? _b : [];
            for (const signal of targetSignals) {
                if (signal.signalNode === targetSignal) {
                    // find the audio or video signal
                    const currentAssignSignal = (_c = signal === null || signal === void 0 ? void 0 : signal.assignSignal) !== null && _c !== void 0 ? _c : null; // what's already assigned
                    if (action === 'add') {
                        if (currentAssignSignal === null) {
                            // nothing assigned yet, so assign the new signal
                            signal.assignSignal = srcSignal;
                        }
                        else if (typeof currentAssignSignal === 'string') {
                            // A single channel assigned
                            if (targetIsOutput) {
                                signal.assignSignal = srcSignal; // only one source assigned to an output
                            }
                            else {
                                // an input can be assigned to multiple outputs
                                if (currentAssignSignal && Array.isArray(currentAssignSignal)) {
                                    if (currentAssignSignal.length > 0) {
                                        currentAssignSignal.push(srcSignal);
                                    }
                                    else {
                                        // Don't want to an array with 1 value, assign as string
                                        signal.assignSignal = srcSignal;
                                    }
                                }
                                else {
                                    // Assigned signal is not an array, but already has a value
                                    // to create an array
                                    signal.assignSignal = [currentAssignSignal, srcSignal];
                                }
                            }
                        }
                        else if (Array.isArray(currentAssignSignal)) {
                            signal.assignSignal = [...currentAssignSignal, srcSignal];
                        }
                    }
                    else if (action === 'remove') {
                        if (typeof currentAssignSignal === 'string') {
                            if (currentAssignSignal === srcSignal) {
                                signal.assignSignal = null;
                            }
                        }
                        else if (Array.isArray(currentAssignSignal)) {
                            // Remove the signal from the array
                            const newAssignSignal = currentAssignSignal.filter(assignSig => assignSig !== srcSignal);
                            // Determine how to present the result as a string or array
                            if (currentAssignSignal.length > 0) {
                                if (Array.isArray(newAssignSignal) &&
                                    newAssignSignal.length === 1) {
                                    signal.assignSignal = newAssignSignal[0];
                                }
                                else {
                                    signal.assignSignal = newAssignSignal;
                                }
                            }
                            else {
                                signal.assignSignal = null;
                            }
                        }
                    }
                }
            }
            // Update the endpoint with the new signal information
            this.endpoints[targetEndpointID].signals = targetSignals;
            // Format the information for the response
            return this.createNotifySignals(targetSignals);
        }
        return undefined;
    }
    createController() {
        const endpoint = {
            index: 1,
            endpointID: 'ctl1',
            endpointType: 'IP-JP4-CL-10',
            hostname: 'IP-JP4-CL-10-1CAE3E501000',
            alias: '',
            fileName: '63b2f376-a249-6597-e309-e4e2b86947c1',
            signals: [],
            processing: [],
            interfaces: [
                {
                    interfaceID: 1,
                    hostIP: '169.254.6.238',
                    netmask: '255.255.0.0',
                    gateway: '192.168.100.254',
                    dns1: '8.8.8.8',
                    dns2: '',
                    mode: 'autoip',
                    autoDNS: true,
                    interfaceMetric: 1,
                },
                {
                    interfaceID: 2,
                    hostIP: '192.168.100.181',
                    netmask: '255.255.255.0',
                    gateway: '192.168.100.254',
                    dns1: '8.8.8.8',
                    dns2: '',
                    mode: 'dhcp',
                    autoDNS: true,
                    VID: 0,
                    presetVLANID: false,
                    interfaceMetric: 2,
                },
            ],
            workingMode: 'JP4',
        };
        return endpoint;
    }
    createNotifySignalsFromEndpoint(endpointID) {
        const signals = this.endpoints[endpointID].signals;
        const result = [];
        for (const signal of signals !== null && signals !== void 0 ? signals : []) {
            result.push({ signalNode: signal.signalNode, assignSignal: signal.assignSignal });
        }
        return result;
    }
    createNotifySignals(signals) {
        const result = [];
        for (const signal of signals !== null && signals !== void 0 ? signals : []) {
            result.push({ signalNode: signal.signalNode, assignSignal: signal.assignSignal });
        }
        return result;
    }
    createDecoders(num) {
        for (let i = 1; i <= num; i++) {
            const endpoint = this.createDecoder(i);
            this.endpoints[endpoint.endpointID] = endpoint;
        }
    }
    createDecoder(index) {
        const endpoint = {
            index: index,
            endpointID: `out${index}`,
            endpointType: 'IP-JP4-RX-10',
            hostname: `IP-JP4-RX-10-1CAE3E0001${(index - 1).toString(16).padStart(2, '0')}`,
            alias: '',
            fileName: `55555-2222-3333${(index - 1).toString(16)}`,
            signals: [
                {
                    type: 'video',
                    map: 1,
                    signalNode: `out${index}-videorx1`,
                    assignSignal: `in${index}-videotx1`,
                    availPorts: ['HDMI_OUT_1'],
                    srcPort: '',
                    direction: 'input',
                    outVideoResolution: '',
                    outVideoFPS: 0,
                    comRefOn: 0,
                    comRefOff: 0,
                    timeoutOff: 30,
                    idleImageHash: '5343dc02c869976a55ff51b5c099adf8',
                },
                {
                    type: 'audio',
                    map: 1,
                    signalNode: `out${index}-audiorx1`,
                    assignSignal: `in${index}-audiotx1`,
                    availPorts: ['HDMI_OUT_1_&_L/R_OUT_1'],
                    dstPort: '',
                    direction: 'input',
                },
                {
                    type: 'infrared',
                    map: 1,
                    signalNode: `out${index}-infraredtx1`,
                    assignSignal: `in${index}-infraredrx1`,
                    availPorts: ['IR_RX_1'],
                    srcPort: '',
                    direction: 'output',
                },
                {
                    type: 'infrared',
                    map: 1,
                    signalNode: `out${index}-infraredrx1`,
                    assignSignal: `in${index}-infraredtx1`,
                    availPorts: ['IR_TX_1'],
                    dstPort: 'IR_TX_1',
                    direction: 'input',
                },
                {
                    type: 'serial',
                    map: 1,
                    signalNode: `out${index}-serialtx1`,
                    assignSignal: `in${index}-serialrx1`,
                    availPorts: ['RS-232_RX_1'],
                    srcPort: '',
                    direction: 'output',
                },
                {
                    type: 'serial',
                    map: 1,
                    signalNode: `out${index}-serialrx1`,
                    assignSignal: `in${index}-serialtx1`,
                    availPorts: ['RS-232_TX_1'],
                    srcPort: '',
                    dstPort: 'RS-232_TX_1',
                    direction: 'input',
                },
                {
                    type: 'usb',
                    map: 1,
                    signalNode: `out${index}-usbrx1`,
                    assignSignal: `in${index}-usbtx1`,
                    availPorts: ['USB_DEVICE_1'],
                    dstPort: 'USB_DEVICE_1',
                    direction: 'input',
                    usbEnumKBM: true,
                },
            ],
            ddc: [
                {
                    ddcPort: 'HDMI_OUT_1',
                    hdcpMode: 'auto',
                    linkStatus: false,
                },
            ],
            uart: [
                {
                    uartID: 1,
                    uartPort: 'RS-232_1',
                    uartBaud: 115200,
                    uartByte: 8,
                    uartParity: 'none',
                    uartBypass: false,
                    uartStop: 1,
                    uartDelim: '0D 0A',
                    uartRxFormat: '',
                },
            ],
            processing: [
                {
                    processID: 1,
                    processName: 'analogAudio',
                    audioOutVolume: 100,
                    audioOutMute: false,
                },
            ],
            interfaces: [
                {
                    interfaceID: 1,
                    hostIP: `169.254.1.${index.toString()}`,
                    netmask: '',
                    gateway: '',
                    dns1: '',
                    dns2: '',
                    mode: 'dhcp',
                    autoDNS: false,
                    interfaceMetric: -1,
                },
                {
                    interfaceID: 2,
                    hostIP: `169.254.42.${index.toString()}`,
                    netmask: '255.255.0.0',
                    gateway: '169.254.0.1',
                    dns1: '',
                    dns2: '',
                    mode: 'dhcp',
                    autoDNS: false,
                    VID: 0,
                    presetVLANID: false,
                    interfaceMetric: -1,
                },
            ],
            transport: 'transport_ssh',
            identifyStatus: '',
            powerStatus: 'on',
            onlineStatus: 'online',
            fwVersion: '1.10.54',
        };
        return endpoint;
    }
    createEncoders(num) {
        for (let i = 1; i <= num; i++) {
            const endpoint = this.createEncoder(i);
            this.endpoints[endpoint.endpointID] = endpoint;
        }
    }
    // In devices
    createEncoder(index) {
        const endpoint = {
            index: index,
            endpointID: `in${index}`,
            endpointType: 'IP-JP4-TX-10',
            hostname: `IP-JP4-TX-10-1CAE3E0000${(index - 1).toString(16).padStart(2, '0')}`,
            alias: '',
            fileName: `11111-2222-3333${(index - 1).toString(16)}`,
            signals: [
                {
                    type: 'video',
                    map: 1,
                    signalNode: `in${index}-videotx1`,
                    assignSignal: `out${index}-videorx1`,
                    availPorts: ['HDMI_IN_1'],
                    srcPort: '',
                    direction: 'output',
                    inVideoResolution: 'No signal',
                    inVideoFPS: 0,
                },
                {
                    type: 'audio',
                    map: 1,
                    signalNode: `in${index}-audiotx1`,
                    assignSignal: `out${index}-audiorx1`,
                    availPorts: ['HDMI_IN_1', 'L/R_IN_1'],
                    srcPort: 'HDMI_IN_1',
                    direction: 'output',
                    inAudioType: '',
                    inAudioFreq: 0,
                    inAudioSample: 0,
                    inAudioChannel: 0,
                },
                {
                    type: 'infrared',
                    map: 1,
                    signalNode: `in${index}-infraredtx1`,
                    assignSignal: `out${index}-infraredrx1`,
                    availPorts: ['IR_RX_1'],
                    srcPort: '',
                    direction: 'output',
                },
                {
                    type: 'infrared',
                    map: 1,
                    signalNode: `in${index}-infraredrx1`,
                    assignSignal: `out${index}-infraredtx1`,
                    availPorts: ['IR_TX_1'],
                    dstPort: 'IR_TX_1',
                    direction: 'input',
                },
                {
                    type: 'serial',
                    map: 1,
                    signalNode: `in${index}-serialtx1`,
                    assignSignal: `out${index}-serialrx1`,
                    availPorts: ['RS-232_RX_1'],
                    srcPort: '',
                    direction: 'output',
                },
                {
                    type: 'serial',
                    map: 1,
                    signalNode: `in${index}-serialrx1`,
                    assignSignal: `out${index}-serialtx1`,
                    availPorts: ['RS-232_TX_1'],
                    dstPort: 'RS-232_TX_1',
                    direction: 'input',
                },
                {
                    type: 'usb',
                    map: 1,
                    signalNode: `in${index}-usbtx1`,
                    assignSignal: `out${index}-usbrx1`,
                    availPorts: ['USB_HOST_1'],
                    srcPort: '',
                    direction: 'output',
                    usbEnumKBM: true,
                },
            ],
            ddc: [
                {
                    ddcPort: 'HDMI_IN_1',
                    hdcpMode: 'auto',
                    edidData: '00 ff ff',
                    linkStatus: true,
                },
            ],
            uart: [
                {
                    uartID: 1,
                    uartPort: 'RS-232_1',
                    uartBaud: 115200,
                    uartByte: 8,
                    uartParity: 'none',
                    uartBypass: false,
                    uartStop: 1,
                    uartDelim: '0D 0A',
                    uartRxFormat: '',
                },
            ],
            processing: [
                {
                    processID: 1,
                    processName: 'analogAudio',
                    audioOutVolume: 100,
                    audioOutMute: false,
                },
            ],
            interfaces: [
                {
                    interfaceID: 1,
                    hostIP: `169.254.1.${index.toString()}`,
                    netmask: '',
                    gateway: '',
                    dns1: '',
                    dns2: '',
                    mode: 'dhcp',
                    autoDNS: false,
                    interfaceMetric: -1,
                },
                {
                    interfaceID: 2,
                    hostIP: `169.254.42.${index.toString()}`,
                    netmask: '255.255.0.0',
                    gateway: '169.254.0.1',
                    dns1: '',
                    dns2: '',
                    mode: 'dhcp',
                    autoDNS: false,
                    VID: 0,
                    presetVLANID: false,
                    interfaceMetric: -1,
                },
            ],
            transport: 'transport_ssh',
            identifyStatus: '',
            powerStatus: 'on',
            onlineStatus: 'online',
            fwVersion: '3.10.01',
        };
        return endpoint;
    }
    // Finds the 'audio processing' associated with the specific decoder signalNode
    getVolumeAndMute(endpointID) {
        var _a, _b;
        const dec = (_a = this.endpoints[endpointID]) !== null && _a !== void 0 ? _a : {};
        const proc = ((_b = dec === null || dec === void 0 ? void 0 : dec.processing) !== null && _b !== void 0 ? _b : []).find(process => process.processName === 'analogAudio');
        return proc;
    }
    findSignalNode(signals, signalType, srcIsTx = false) {
        const specificSignal = signals.filter(sig => { var _a; return sig.type === signalType && ((_a = sig === null || sig === void 0 ? void 0 : sig.signalNode) !== null && _a !== void 0 ? _a : '').includes(srcIsTx ? 'rx' : 'tx'); });
        if (debug) {
            this.log.debug(`findSignalNode: signalType: ${signalType}, ${JSON.stringify(specificSignal, null, 4)}`);
        }
        if (specificSignal.length >= 1) {
            return specificSignal[0].signalNode;
        }
        return undefined;
    }
    // Finds the 'signal' associated with the specific decoder signalNode
    findEndpointSignal(outputSignalNode) {
        var _a, _b;
        for (const decoder of (_a = Object.values(this.endpoints)) !== null && _a !== void 0 ? _a : []) {
            if (decoder.endpointID.startsWith('out')) {
                const signals = (_b = decoder === null || decoder === void 0 ? void 0 : decoder.signals) !== null && _b !== void 0 ? _b : [];
                for (const signal of signals) {
                    if (signal.signalNode === outputSignalNode) {
                        return signal;
                    }
                }
            }
        }
        return undefined;
    }
    getEndpointIDFromSignal(signalName) {
        const name = Array.isArray(signalName) ? signalName[0] : signalName;
        if (name)
            return name.replace(/((?:out|in)\d+)-.+/, '$1');
        return undefined;
    }
    getMatrixRouting(outputSignalNode) {
        const signal = this.findEndpointSignal(outputSignalNode);
        return signal ? signal.assignSignal : undefined;
    }
}
Netvio.emulatorType = 'socketEmulator';
Netvio.key = '-O46FUaHKiQKzDCezCz0';
